import * as React from 'react'
import { Button, CardBody } from 'reactstrap'
import { VCSpinner } from '../shared/spinner'

const { I18n } = window as any

interface TwoFactorInitiateViewProps {
  loading: boolean
  onInitiate: () => void
}

function TwoFactorInitiateView({ loading, onInitiate }: TwoFactorInitiateViewProps): JSX.Element {
  return (
    <CardBody>
      <p>{I18n.t('users.two_factor.setup_instructions')}</p>

      <Button color="primary" onClick={onInitiate} disabled={loading}>
        {loading ? <VCSpinner visible={loading} viewType="inline" size="1" /> : I18n.t('users.two_factor.setup_button')}
      </Button>
    </CardBody>
  )
}

export default TwoFactorInitiateView
